// frontend/src/services/socketOperator.js
// Socket.IO client for /operator namespace
import { io } from 'socket.io-client';

class SocketOperator {
  constructor() {
    this.socket = null;
    this.listeners = {};
    this.connected = false;
  }

  connect(token) {
    if (this.socket && this.socket.connected) return this.socket;

    this.socket = io("/operator", {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
      auth: { token }
    });

    this.socket.on('connect', () => {
      console.log('[Socket] Operator connected: ' + this.socket.id);
      this.connected = true;
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[Socket] Operator disconnected: ' + reason);
      this.connected = false;
    });

    this.socket.on('connect_error', (err) => {
      console.warn('[Socket] Operator connection error:', err.message);
    });

    this.socket.on('auth_error', (err) => {
      console.error('[Socket] Operator auth error:', err);
      this.connected = false;
    });

    return this.socket;
  }

  joinCart(cartId) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('join-cart', { cartId });
    }
  }

  leaveCart(cartId) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('leave-cart', { cartId });
    }
  }

  requestSync(cartIds) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('reconnect:request-sync', { cartIds });
    }
  }

  on(event, callback) {
    if (!this.socket) return;
    this.socket.on(event, callback);
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);
  }

  off(event, callback) {
    if (!this.socket) return;
    if (callback) {
      this.socket.off(event, callback);
    } else {
      this.socket.off(event);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
    }
  }
}

export default new SocketOperator();
